var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-back-button",on:{"click":function($event){return _vm.$router.back()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }